import mediumZoom from "medium-zoom";
import MediaQueries from "../utils/MediaQueries";

const initPictureZoom = (backgroundColor = "white") => {
    if(MediaQueries.isMobile())
        return;

    let pictures = document.querySelectorAll(".article-picture:not(.article-item--full) img:not(.medium-zoom-image)");

    mediumZoom(pictures, {
        background: backgroundColor
    });
};

export default initPictureZoom;


// WEBPACK FOOTER //
// ./js/page/PictureZoom.js